import type { AccountOverviewSharedState } from "../types/state";

const initialAccountOverviewSharedState: AccountOverviewSharedState = {
    // Visible when websites selector is opened
    isPageOverlayVisible: false,
    // Currently selected countries on the page
    selectedCountriesIds: [],
    // Web source selection
    selectedWebSourceId: null,
};

export default initialAccountOverviewSharedState;
